/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { LoadbeeFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { LoadbeeFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';

export const loadbeeDataMock: LoadbeeFragmentFragment = {
  brand: {
    image: 'https://bilder.imwalking.de/marken/imwalkingde/nikesportswear.gif',
    name: 'Nike Sportswear',
  },
  loadbee: {
    url: 'loadbee url',
  },
};

export function getLoadbeeFragmentedData(data?: LoadbeeFragmentFragment) {
  return makeFragmentData(data || loadbeeDataMock, LoadbeeFragmentFragmentDoc);
}
